import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const variants = {
  hidden:  { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0 }
};

export default function RevealSection({ children, delay = 0, amount = 0.2, once = true }) {
  const ref = useRef(null);
  const inView = useInView(ref, { amount, once }); // anima quando a seção entra na tela

  return (
    <motion.section
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={variants}
      transition={{ duration: 0.5, ease: "easeOut", delay }}
      style={{ willChange: "transform, opacity" }}
    >
      {children}
    </motion.section>
  );
}
